module.exports = __webpack_public_path__ + "media/images/proof_links/colored/tumblr-a3438cfc927b530aa1d079a4949793df.svg";